import { render, staticRenderFns } from "./lezioniListTable.vue?vue&type=template&id=4478bd84&"
import script from "./lezioniListTable.vue?vue&type=script&lang=ts&"
export * from "./lezioniListTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports